module.exports = __webpack_public_path__ + "static/media/InternalMedicineImage3@2x.84d1f85c.png";